/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsAPIWrapper, AgmCoreModule } from '@agm/core';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { ToastrModule } from 'ngx-toastr';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { SignupComponent } from './signup/signup.component';
import { SignupsuccessComponent } from './signupsuccess/signupsuccess.component';
import { SignupcompleteComponent } from './signupcomplete/signupcomplete.component';
import { EmailPinVerificationComponent } from './email-pin-verification/email-pin-verification.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { PasswordrequestsuccessComponent } from './passwordrequestsuccess/passwordrequestsuccess.component';
import { PasswordresetsuccessComponent } from './passwordresetsuccess/passwordresetsuccess.component';
import { OauthGuard } from './services/oauth-guard.service';
import { CompanySummaryComponent } from './company-summary/company-summary.component';
import { CompanySummary2Component } from './company-summary2/company-summary2.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { UpdateDataComponent } from './pages/asset/asset-management/update-data/update-data.component';
import { FilterDataComponent } from './pages/asset/asset-management/filter-data/filter-data.component';
import { CompareValidatorModule } from 'angular-compare-validator';
import { ViewHistoryComponent } from './pages/asset/asset-details/view-history/view-history.component';
import { UpdateMeterReadingComponent } from './pages/asset/asset-details/view-history/update-meter-reading/update-meter-reading.component';
import { ViewDetailModalComponent } from './pages/popups/view-detail-modal/view-detail-modal.component';
import { WoSearchComponent } from './pages/dashboard/active-cases/wo-search/wo-search.component';
import { PreferredProviderDetailsComponent } from './pages/profile/Profile Popups/preferred-provider-details/preferred-provider-details.component';
import { SubcustomerDetailsComponent } from './pages/profile/Profile Popups/subcustomer-details/subcustomer-details.component';
import { ServicePricingLimitsComponent } from './pages/profile/Profile Popups/service-pricing-limits/service-pricing-limits.component';
import { NewProtocolComponent } from './pages/profile/Profile Popups/new-protocol/new-protocol.component';
import { AddEditNationalAccountComponent } from './pages/profile/Profile Popups/add-edit-national-account/add-edit-national-account.component';
import { InvoiceModelComponent } from './pages/accounting/invoice-model/invoice-model.component';
import { WoActivePopupComponent } from './pages/popups/wo-active-popup/wo-active-popup.component';
import { ShowWoPopupComponent } from './pages/popups/show-wo-popup/show-wo-popup.component';
import { InviteUserComponent } from './pages/profile/Profile Popups/invite-user/invite-user.component';
import { SharedPipeModule } from './shared/pipe/sharedPipe.module';
import { AddInnermappingDialogComponent } from './pages/asset/asset-import-dialogs/add-innermapping-dialog/add-innermapping-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddDefaultMappingDialogComponent } from './pages/asset/asset-import-dialogs/add-default-mapping-dialog/add-default-mapping-dialog.component';
import { AddDateFormatDialogComponent } from './pages/asset/asset-import-dialogs/add-date-format-dialog/add-date-format-dialog.component';
import { AddHotAlertDailogComponent } from './pages/asset/asset-import-dialogs/add-hot-alert-dailog/add-hot-alert-dailog.component';
import { StartTourComponent } from './pages/popups/start-tour/start-tour.component';
import { ViewWoDetailsComponent } from './pages/popups/view-wo-details/view-wo-details.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SimplifieddialogComponent } from './pages/asset/simplifieddialog/simplifieddialog.component';
import { FollowStepsDialogComponent } from './pages/popups/follow-steps-dialog/follow-steps-dialog.component';
import { AddEditHierarchyComponent } from './pages/profile/Profile Popups/add-edit-hierarchy/add-edit-hierarchy.component';
import { CompleteDemoDialogComponent } from './pages/dashboard/new-case-management/complete-demo-dialog/complete-demo-dialog.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ProtocolChangeRequestDialogComponent } from './pages/profile/protocols/protocol-change-request-dialog/protocol-change-request-dialog.component';
import { CustomerListComponent } from './login/customer-list/customer-list.component';
import { ConfirmationDialogComponent } from './login/confirmation-dialog/confirmation-dialog.component';
import { ShareModuleModule } from './share-module/share-module.module';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CoreModule } from './@core/core.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxPrintModule } from 'ngx-print';
import { ViewAttachmentComponent } from './pages/popups/view-attachment/view-attachment.component';
import { ViewNotesComponent } from './pages/popups/view-notes/view-notes.component';
import { AddNotesComponent } from './pages/popups/add-notes/add-notes.component';
import { ChangePasswordModalComponent } from './pages/profile/Profile Popups/change-password-modal/change-password-modal.component';
import { InvitationExpireComponent } from './invitation-expire/invitation-expire.component';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import { NbThemeModule, NbLayoutModule, NbTooltipModule, NbWindowModule} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

@NgModule({
    declarations: [
        AppComponent,
        UpdateDataComponent,
        FilterDataComponent,
        LoadingComponent,
        LoginComponent,
        LogoutComponent,
        SignupComponent,
        SignupsuccessComponent,
        SignupcompleteComponent,
        EmailPinVerificationComponent,
        ForgetpasswordComponent,
        PasswordresetComponent,
        PasswordrequestsuccessComponent,
        PasswordresetsuccessComponent,
        CompanySummaryComponent,
        CompanySummary2Component,
        TermsAndConditionsComponent,
        ViewHistoryComponent,
        UpdateMeterReadingComponent,
        ViewDetailModalComponent,
        WoSearchComponent,
        PreferredProviderDetailsComponent,
        SubcustomerDetailsComponent,
        ServicePricingLimitsComponent,
        NewProtocolComponent,
        AddEditNationalAccountComponent,
        InvoiceModelComponent,
        ViewNotesComponent,
        WoActivePopupComponent,
        ShowWoPopupComponent,
        InviteUserComponent,
        AddInnermappingDialogComponent,
        AddDefaultMappingDialogComponent,
        AddDateFormatDialogComponent,
        AddHotAlertDailogComponent,
        StartTourComponent,
        ViewWoDetailsComponent,
        WelcomeComponent,
        SimplifieddialogComponent,
        FollowStepsDialogComponent,
        AddEditHierarchyComponent,
        ViewAttachmentComponent,
        CompleteDemoDialogComponent,
        ProtocolChangeRequestDialogComponent,
        CustomerListComponent,
        ConfirmationDialogComponent,
        AddNotesComponent,
        ChangePasswordModalComponent,
        InvitationExpireComponent,
        AlertMessageComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgbModule.forRoot(),
        ThemeModule.forRoot(),
        ToastrModule.forRoot(),
        NbThemeModule.forRoot({ name: 'default' }),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCVDcQzkPeKIxepuEiyNW38oZ9n-DM25gM'
        }),
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.circle,
            backdropBackgroundColour: 'rgba(0,0,0,0.1)',
            backdropBorderRadius: '4px',
            primaryColour: '#8edd80',
            secondaryColour: '#ffffff',
            tertiaryColour: '#ffffff'
        }),
        MatDialogModule,
        InfiniteScrollModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        MatButtonModule,
        Ng2SmartTableModule,
        CompareValidatorModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatTabsModule,
        MatAutocompleteModule,
        MatNativeDateModule,
        MatIconModule,
        SharedPipeModule,
        DragDropModule,
        NgxEchartsModule,
        ShareModuleModule,
        CoreModule.forRoot(),
        NgxMaterialTimepickerModule,
        NgxPrintModule,
        NbEvaIconsModule
    ],
    bootstrap: [AppComponent],
    providers: [
        GoogleMapsAPIWrapper,
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },
        OauthGuard
    ]
})
export class AppModule {
}
